import { get, post, put, remove } from '@/utils/request';
import type { Dict, DictTmpl, FieldType } from '../dict/type';

const BASE_URL = '/cmp-doc/tmpl/dict';

/** 获取当前租户可以访问的字典模板列表 */
export function getDictTemplateList() {
  return get<DictTmpl[]>(`${BASE_URL}/dict_tmpls`, {}, {}, 'document');
}

/** 获取指定模板的字典列表 */
export function getDictListByTemplate(params) {
  return get<any>(`${BASE_URL}/dicts`, params, {}, 'document');
}

/** 获取指定模板的字典拓展属性 */
export function getDictMetaByTemplate(params) {
  return get<Dict[]>(`${BASE_URL}/meta`, params, {}, 'document');
}

/** 添加字典 */
export function addDict(templateCode: string, data: any) {
  return post<number>(`${BASE_URL}/add_dict?templateCode=${templateCode}`, data, {}, 'document');
}

/** 更新字典 */
export function updateDict(templateCode: string, data: any) {
  return post(`${BASE_URL}/modify_dict?templateCode=${templateCode}`, data, {}, 'document');
}

/** 删除字典 */
export function deleteDict(templateCode: string, data: any) {
  return post(`${BASE_URL}/remove_dict?templateCode=${templateCode}`, data, {}, 'document');
}

/** 交换字典排序值 */
export function exchangeDictSort(params: { dictId1: number; dictId2: number; templateCode: string }) {
  const { dictId1, dictId2, templateCode } = params;
  return post(`${BASE_URL}/exchange_sort?dictId1=${dictId1}&dictId2=${dictId2}&templateCode=${templateCode}`, {}, {}, 'document');
}

/** 获取字典字段类型 */
export function getDictFieldTypes() {
  return get<FieldType[]>(`${BASE_URL}/field_types`, {}, {}, 'document');
}


// 切换字典编辑模式复制接口复制文档复制地址
export function switchEditMode(params) {
  return get(`${BASE_URL}/switch_edit_mode`, params, {}, 'document');
}